import type { IconData } from '@stacksjs/iconify-core'

export const bathroom: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M464 280H80V100a51.26 51.26 0 0 1 15.113-36.485l.4-.4a51.69 51.69 0 0 1 58.6-10.162a79.1 79.1 0 0 0 11.778 96.627l10.951 10.951l-20.157 20.158l22.626 22.626l20.157-20.157L311.157 71.471l20.157-20.157l-22.627-22.627l-20.158 20.157l-10.951-10.951a79.086 79.086 0 0 0-100.929-8.976A83.61 83.61 0 0 0 72.887 40.485l-.4.4A83.05 83.05 0 0 0 48 100v180H16v32h32v30.7a24 24 0 0 0 1.232 7.589L79 439.589A23.97 23.97 0 0 0 101.766 456h12.9L103 496h33.333L148 456h208.1l12 40h33.4l-12-40h20.73A23.97 23.97 0 0 0 433 439.589l29.766-89.3A24 24 0 0 0 464 342.7V312h32v-32ZM188.52 60.52a47.025 47.025 0 0 1 66.431 0L265.9 71.471L199.471 137.9l-10.951-10.949a47.027 47.027 0 0 1 0-66.431M432 341.4L404.468 424H107.532L80 341.4V312h352Z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default bathroom
